<script setup lang="ts">
import { ref, watch, toRefs, computed, onMounted } from 'vue';
const emit = defineEmits(['update:modelValue', 'change']);

interface List {
  id: number;
  label: string;
}

// 定义 props 类型
interface Props {
  modelValue: number; //当前值
  list: List[]; // 列表
  disabled?: boolean; // 是否禁用
  disabledOther?: boolean; // 是否禁用其它选项
  showId?: number; // 显示的id
  icon?: string; // 图标
}

// 使用 withDefaults 设置默认值
const props = defineProps({
  modelValue: Number,
  list: {
    type: Array as () => List[], // 类型断言
    default: () => [],
  },
  disabled: Boolean, // 是否禁用
  disabledOther: {
    type: Boolean,
    default: false,
  }, // 是否禁用其它选项
  showId: {
    type: Number,
    default: 0,
  },
  icon: {
    type: String,
    default: 'icon_host',
  },
});

const { list, disabled, disabledOther, showId, icon } = toRefs(props);
const currentTab = ref(0);

const currentValue = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
});

const selectTab = (id: number, index: number) => {
  if (props.disabled) return;
  if (props.disabledOther && id !== showId.value) return;
  currentValue.value = id;
  currentTab.value = index;
  emit('change', id);
};

watch(
  () => currentValue.value,
  (newValue) => {
    currentTab.value = list.value.findIndex(
      (item) => item.id === props.modelValue
    );
  },
  { immediate: true }
);

onMounted(() => {});
</script>

<template>
  <div class="tabs-wrap">
    <div class="tabs-box fr-ac" :class="{ opa4: disabled }">
      <div
        v-for="(item, index) in list"
        :key="item.id"
        class="tabs-item fr-ac"
        :class="{
          'item-active': currentValue === item.id,
          'opa4 cursor-not-allowed': disabledOther && item.id !== showId,
        }"
        @click="selectTab(item.id, index)"
      >
        <IconFont
          v-if="currentValue === item.id"
          :name="icon"
          class="mr-2"
          :size="14"
        />
        <div class="fs-12">{{ item.label }}</div>
      </div>
      <view
        class="translocation-box"
        :style="{ transform: `translateX(${88 * currentTab}px)` }"
      >
      </view>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tabs-wrap {
  padding: 3px;
  background: var(--tab-bg-color);
  border-radius: var(--border-radius);
  cursor: pointer;
}

.tabs-box {
  height: 26px;
  border-radius: var(--border-radius);
  position: relative;
  z-index: 1;

  .tabs-item {
    width: 88px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--text-color-light);
    border-radius: var(--border-radius);
  }

  .item-active {
    color: var(--text-color-white);
    position: relative;
    z-index: 1;
  }

  .cursor-not-allowed {
    cursor: not-allowed;
  }

  .translocation-box {
    transition: all 0.5s;
    background: var(--tab-bg-color-active);
    position: absolute;
    left: 0;
    top: 0;
    width: v-bind('(100 / props.list.length) + "%"');
    height: 100%;
    z-index: 0;
    border-radius: var(--border-radius);
  }
}
</style>
